// components/Loader.js
import React from "react";
import { Spinner } from "reactstrap";

const Loader = ({ variant = "page", size = "lg", color = "primary" }) => {
  // Variants: page (full page), card (inside card), inline (small inline)
  const variants = {
    page: {
      height: "60vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    card: {
      padding: "3rem 0",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    inline: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
    },
  };

  const sizes = {
    sm: { width: "1.5rem", height: "1.5rem" },
    md: { width: "2.5rem", height: "2.5rem" },
    lg: { width: "4rem", height: "4rem" },
  };

  return (
    <div style={variants[variant]}>
      <Spinner style={sizes[size]} color={color} />
    </div>
  );
};

export default Loader;